import { Base } from 'active-resource';
import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';

/**
 * Relationship classes
 */
export class BrandAttributes {
  name: string = null;
  domain: string = null;
  loginCopy: string = null;
  removeSchoolSignup = true;
  logo = {
    downloadUrl: '',
    mediumUrl: '',
  };
  hideFooters = true;
  createdAt: string = null;
  id: string = null;
  updatedAt: string = null;
}

export class BrandBelongsTo {}
export class BrandHasOne {}
export class BrandHasMany {}

/**
 * Utility interfaces
 */
export interface BrandMethods {}

export interface BrandInterface extends BrandAttributes, BrandBelongsTo, BrandType {}

type BrandType = GConstructor<BrandInterface>;

export interface BrandResource extends Base<BrandAttributes>, BrandInterface, BrandMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<BrandAttributes>({
    queryName: 'brands',
    className: 'Brand',
    AttributesClass: BrandAttributes,
    BelongsToClasses: [
      {
        Klass: BrandBelongsTo,
      },
    ],
  });

export const BrandResourceClass = <TBase extends BrandType>(BaseConstructor: TBase): TBase =>
  class extends BaseConstructor implements BrandMethods {};

export class BrandResource extends ClassExtender<BrandInterface>(BaseClass, BrandResourceClass) {}

/**
 * Resource instance
 */
export const Brand = APILibrary.createResource<BrandResource>(BrandResource);
